<template>
  <outside-click @outside-click-action="handleDeleteCancel">
    <icon-button
      type="button"
      icon="delete_forever"
      :classes="isDeleteConfirmStep ? 'delete-confirm' : '-ico-only delete'"
      :label="isDeleteConfirmStep ? 'Confirm' : 'Delete'"
      :aria-label="isDeleteConfirmStep ? 'Confirm Delete Collection' : 'Delete Collection'"
      :aria-live="isDeleteConfirmStep ? 'assertive' : 'off'"
      :submitting="processing"
      submitting-label="Deleting..."
      :icons-outlined="false"
      :reduce="!isDeleteConfirmStep"
      @click-action="handleDelete"
    />
  </outside-click>
</template>

<script setup lang="ts">
import IconButton from '@/components/buttons/icon-button.vue'
import { ref } from 'vue'
import { fbApi } from '@/utils/http-api'
import OutsideClick from '@/components/tool-tips/outside-click.vue'

/** PROPS **/
const props = withDefaults(
  defineProps<{
    filterCollectionId: number
  }>(),
  {},
)

/** EMITS **/
const emit = defineEmits(['delete-confirm', 'delete-cancel', 'deleted'])

/** STATE **/
const isDeleteConfirmStep = ref(false)
const processing = ref(false)

/** COMPUTED **/

/** WATCHERS **/

/** METHODS **/
function handleDeleteCancel() {
  isDeleteConfirmStep.value = false
  emit('delete-cancel')
}
async function handleDelete() {
  // step 1
  if (!isDeleteConfirmStep.value) {
    isDeleteConfirmStep.value = true
    emit('delete-confirm')
    return
  }

  // avoid double submit
  if (processing.value) {
    return
  }

  // step 2
  try {
    processing.value = true

    // delete, will show error modal on fail
    let res = await fbApi.delete(`/filter-collections/${props.filterCollectionId}`)

    if (!res || !res.body) {
      throw Error('Missing response')
    }

    emit('deleted', props.filterCollectionId)
  } catch (e) {
    console.error(e)
  } finally {
    processing.value = false
    isDeleteConfirmStep.value = false
  }
}
</script>
